import { render, staticRenderFns } from "./PracaXPerfil.vue?vue&type=template&id=102a274c&scoped=true&"
import script from "./PracaXPerfil.vue?vue&type=script&lang=js&"
export * from "./PracaXPerfil.vue?vue&type=script&lang=js&"
import style0 from "./PracaXPerfil.vue?vue&type=style&index=0&id=102a274c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102a274c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
